import {
    Component,
    Input,
    OnInit,
    Output,
    EventEmitter,
    OnChanges,
    forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from '../base_control_value_accessor/base';
import { Currencies } from 'src/app/models/currency_master_model/currency';
import { CurrencyService } from 'src/app/services/currency.service';

@Component({
    selector: 'logzy-currency-search',
    templateUrl: './currency-search.component.html',
    styleUrls: ['./currency-search.component.scss', '../form-field.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => CurrencySearchComponent),
        },
    ],
})
export class CurrencySearchComponent
    extends BaseControlValueAccessor
    implements OnInit, OnChanges {
    currencies: Currencies[] = [];

    @Input() updatedCurrency: string;
    @Output() newCurrency: EventEmitter<any> = new EventEmitter();

    selectedCurrency: string;

    constructor(private currencyService: CurrencyService) {
        super();
    }

    ngOnInit(): void {
        this.currencies = this.currencyService.currencies;
        this.selectedCurrency = this.updatedCurrency;
    }

    setCurrency() {
        this.newCurrency.emit(this.selectedCurrency);
    }

    ngOnChanges() {
        this.selectedCurrency = this.updatedCurrency;
        this.newCurrency.emit(this.selectedCurrency);
    }
}
